import React, { useContext } from 'react';
import { useHistory } from "react-router-dom"; 

import consumoContext from '../../../context/consumos/consumoContext';
import proyectoContext from '../../../context/proyectos/proyectoContext';



const Consumo = ({consumo}) => {

    // obtener el state de consumo
    const consumosContext = useContext(consumoContext);
    const { eliminarConsumo, obtenerConsumosPyt, obtenerConsumoEd } = consumosContext;

    // extraer si un proyecto esta activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto } = proyectosContext;
    // Array destructuring para extraer el proy actual
    const [proyectoActual] = proyecto;

    const { nombre, potencia, uso, consumoE } = consumo;

    const history = useHistory();

    // eliminar un consumo
    const eliminacionConsumo = id => {
        eliminarConsumo(id, proyectoActual._id);
        obtenerConsumosPyt(proyectoActual.id);
    };
    

    // funcion que redirige de forma programada
    const redireccionarEdicion = consumo => {
        obtenerConsumoEd(consumo)
        history.push(`/proyectos/consumos/editar/${consumo._id}`)
    };

    return (  
        <tr className="centrartxt">
            <td>{nombre}</td>
            <td>{potencia} Watts</td>
            <td>{uso} Horas</td>
            <td>{consumoE} Watts hora</td>
            <td className="acciones">
            <div className="btn-group" role="group" aria-label="Basic example">
                <button 
                    type="button"
                    onClick={ () => redireccionarEdicion(consumo)}
                    className="btn btn-primary mr-2 mb-3"
                >Editar
                </button>
                <button
                    type="button"
                    className="btn btn-danger mb-3"
                    onClick={() => eliminacionConsumo(consumo._id)}
                >Eliminar</button>
            </div>
                
            </td>
        </tr>
    );
}
 
export default Consumo;